/**
 * The fets client resolves for every status code rather than rejecting, so without this a refused
 * request looks like a success: react-query's `onError` never runs, an optimistic update is never
 * rolled back, and the user is shown no error. Call this before reading the body of any request
 * whose failure the caller needs to notice.
 *
 * @param action what the request was trying to do, phrased to follow "Failed to " — e.g. `'create the link'`.
 */
export const throwIfNotOk = async (
  response: { ok: boolean; status: number; text: () => Promise<string> },
  action: string
): Promise<void> => {
  if (response.ok) {
    return;
  }

  const body = await response.text().catch(() => '');
  throw new Error(`Failed to ${action} (${response.status}).${body ? ` ${body}` : ''}`);
};
